import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const getDefaultState = () => {
    return {
        userToken : '',
        userName : ''
    }
}

const store = new Vuex.Store({
    state: getDefaultState(),
    mutations: {
        updateUser(state, user) {
            state.userName = user.userName;
            state.userToken = "JWT "+user.userToken;
        },
        reset(state) {
            Object.assign(state, getDefaultState())
        },
    },
    actions: {
        auth(context, user) {
            context.commit('updateUser', user);
        }
    },
    modules: {},
    plugins: [createPersistedState({
        key: 'vuex',
        storage: window.sessionStorage
    })]
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js